import { PER_PAGE_DEFAULT_EMPLOYEES } from "constants";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { storeConfig } from "./config";

export const DEFAULT_PARAMS_LIST_EMPLOYEE = {
  sortType: null,
  no_data: 0,
  page: 1,
  limit: PER_PAGE_DEFAULT_EMPLOYEES,
  isPaging: 0,
};

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: 50,
};

const createEmployeeStore = (set, get) => ({
  // Internal loading for employee store
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),

  // All employees in DB
  allEmployees: [],
  setAllEmployees: (employees) => set({ allEmployees: employees }),

  // Searched employees by using modal search employee
  searchedEmployees: [],
  setSearchedEmployees: (employees) => set({ searchedEmployees: employees }),

  totalSearchedEmployees: 0,
  setTotalSearchedEmployees: (total) => set({ totalSearchedEmployees: total }),

  // Search param
  paramsListEmployee: DEFAULT_PARAMS_LIST_EMPLOYEE,
  setParamsListEmployee: (params) => set({ paramsListEmployee: params }),

  pagination: DEFAULT_PAGINATION,
  setPagination: (params) =>
    set({ pagination: { ...get().pagination, ...params } }),

  // is checkbox 全社員必須受講 checked in course detail page
  isSelectedAllEmployee: false,
  setIsSelectedAllEmployee: (isChecked) =>
    set({ isSelectedAllEmployee: isChecked }),

  // check is user click button search in modal search employee
  isShowSearchData: false,
  setIsShowSearchData: (isShow) => set({ isShowSearchData: isShow }),

  // employee ids selected in course detail page
  selectedEmployeeIds: [],
  setSelectedEmployeeIds: (ids) => set({ selectedEmployeeIds: ids }),

  // Employee ids selected in modal search
  employeeIdsCheckedModal: [],
  setEmployeeIdsCheckedModal: (ids) => set({ employeeIdsCheckedModal: ids }),

  resetSearchEmployee: () =>
    set({
      employeeIdsCheckedModal: [],
      isShowSearchData: false,
      searchedEmployees: [],
      paramsListEmployee: DEFAULT_PARAMS_LIST_EMPLOYEE,
      pagination: DEFAULT_PAGINATION,
    }),

  resetAllEmployee: () =>
    set({
      allEmployees: [],
      selectedEmployeeIds: [],
      employeeIdsCheckedModal: [],
      isSelectedAllEmployee: false,
      isShowSearchData: false,
      searchedEmployees: [],
      totalSearchedEmployees: 0,
      paramsListEmployee: DEFAULT_PARAMS_LIST_EMPLOYEE,
      pagination: DEFAULT_PAGINATION,
    }),
});

export const useEmployeeStore = create(
  storeConfig.devtools
    ? devtools(createEmployeeStore, { name: "employeeStore" })
    : createEmployeeStore
);
